type MlsSource = string;
type MlsId = string;
export type MlsListingKey = `${MlsSource}:${MlsId}`;
export type ListingMlsKeyParts = {
  mlsSource: string;
  mlsId: string;
};

export const buildListingMlsKey = (
  params: ListingMlsKeyParts
): MlsListingKey => {
  return `${params.mlsSource}:${params.mlsId}`;
};

export const extractListingMlsKey = (
  mlsKey: MlsListingKey
): ListingMlsKeyParts => {
  const [mlsSource, mlsId] = mlsKey.split(":");
  return {
    mlsSource,
    mlsId,
  };
};
